"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaConstructionPreprocessResponseToJSON = exports.RosettaConstructionPreprocessResponseFromJSONTyped = exports.RosettaConstructionPreprocessResponseFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function RosettaConstructionPreprocessResponseFromJSON(json) {
    return RosettaConstructionPreprocessResponseFromJSONTyped(json, false);
}
exports.RosettaConstructionPreprocessResponseFromJSON = RosettaConstructionPreprocessResponseFromJSON;
function RosettaConstructionPreprocessResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'options': !runtime_1.exists(json, 'options') ? undefined : _1.RosettaOptionsFromJSON(json['options']),
        'required_public_keys': !runtime_1.exists(json, 'required_public_keys') ? undefined : (json['required_public_keys'].map(_1.RosettaAccountFromJSON)),
    };
}
exports.RosettaConstructionPreprocessResponseFromJSONTyped = RosettaConstructionPreprocessResponseFromJSONTyped;
function RosettaConstructionPreprocessResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'options': _1.RosettaOptionsToJSON(value.options),
        'required_public_keys': value.required_public_keys === undefined ? undefined : (value.required_public_keys.map(_1.RosettaAccountToJSON)),
    };
}
exports.RosettaConstructionPreprocessResponseToJSON = RosettaConstructionPreprocessResponseToJSON;
//# sourceMappingURL=RosettaConstructionPreprocessResponse.js.map